import designDark from "./assets/images/24design-dark.png";
import designLight from "./assets/images/24design-light.png";
import companyDark from "./assets/images/company-dark.png";
import companyLight from "./assets/images/company-light.png";
import css from "./assets/images/css-3.png";
import ecommerceDark from "./assets/images/e-commerce-dark.png";
import ecommerceLight from "./assets/images/e-commerce-light.png";
import ecommerce2Dark from "./assets/images/e-commerce2-dark.png";
import ecommerce2Light from "./assets/images/e-commerce2-light.png";
import node from "./assets/images/node-js.png";

import dashboardDark from "./assets/images/dashboard-dark.png";
import dashboardLight from "./assets/images/dashboard-light.png";

import html from "./assets/images/html-5.png";
import javascript from "./assets/images/js.png";
import next from "./assets/images/nextjs.svg";
import elearningDark from "./assets/images/online-course-dark.png";
import elearningLight from "./assets/images/online-course-light.png";
import seaDark from "./assets/images/order-2-dark.png";
import seaLight from "./assets/images/order-2-light.png";
import react from "./assets/images/react.png";
import realEstateDark from "./assets/images/real-estate-dark.png";
import realEstateLight from "./assets/images/real-estate-light.png";
import redux from "./assets/images/redux.png";
import typescript from "./assets/images/typescript.png";

export const projectData = [
  {
    id: 1,
    title: "E-Commerce",
    img: [ecommerce2Light, ecommerce2Dark],
    languages: ["React.js", "Redux", "Redux Toolkit", "Express.js", "MongoDB"],
    description:
      "This is a MERN project – a comprehensive e-commerce platform offering a wide range of electronic products. Explore easy registration, detailed product information, a user-friendly shopping cart, efficient checkout, order history, and secure password reset. Shop and manage your purchases seamlessly.",
    liveDemo: "http://e-commerce20.netlify.app/",
    github: "https://github.com/shSalman009/MERN-E-Commerce",
  },
  {
    id: 2,
    title: "Dashboard",
    img: [dashboardLight, dashboardDark],
    languages: [
      "React.js",
      "Redux",
      "Redux Toolkit",
      "shadcn/ui",
      "Tailwind CSS",
    ],
    description:
      "The dashboard efficiently handles users, products, orders, categories, brands, and blogs data management for the e-commerce website.",
    liveDemo: "https://ecommerce-20-dashboard.netlify.app",
    github: "https://github.com/shSalman009/Ecommerce-Dashboard",
  },
  {
    id: 3,
    title: "Project SEA",
    img: [seaLight, seaDark],
    languages: ["React.js", "Tailwind CSS"],
    description:
      "This is a NFT selling web platform, built with the latest technologies React.js and Tailwind CSS for a seamless user experience and ensuring exceptional performance and eye catching design. The website is fully functional and offering a dynamic and user friendly interface on all devices. Although I am unable to share the code related to this project due to client confidentiality",
    liveDemo: "https://project-sea.netlify.app/",
    github: "",
  },
  {
    id: 4,
    title: "E-Learning",
    img: [elearningLight, elearningDark],
    languages: ["React.js", "React Bootstrap", "Firebase"],
    description:
      "This is a online course sell application. For created this website I used react-bootstrap along with react Js for front-end and firebase as backend. (Although design may need some improvement)",
    liveDemo: "https://online-school-knowmore.netlify.app",
    github: "https://github.com/shSalman009/E-Learning",
  },

  {
    id: 5,
    title: "E-Commerce",
    img: [ecommerceLight, ecommerceDark],
    languages: ["React.js", "Framer Motion"],
    description:
      "This is an E-Commerce onlie shopping website. In this website you can add, remove, update, clear products from cart , can filter product and search product by name , can purchase your cart items. also can visit and check every single product details. for more details visit website.",
    liveDemo: "https://fantastic-starlight-bf0953.netlify.app",
    github: "https://github.com/shSalman009/e-commerce",
  },
  {
    id: 6,
    title: "IT Company",
    img: [companyLight, companyDark],
    languages: ["HTML", "CSS", "JavaScript"],
    description:
      "This is a simple static IT service company website. <br/> <strong>Used Language</strong> <br/><ul><li><span>HTML</span></li><li><span>CSS</span></li><li><span>JavaScript</span></li></ul> ",
    liveDemo: "https://salmans-brand.netlify.app",
    github: "https://github.com/shSalman009/static-company-webiste",
  },
  {
    id: 7,
    title: "24 Design",
    img: [designLight, designDark],
    languages: ["React.js", "Framer Motion"],
    description:
      "24Design is a client website, serving as a portfolio for an IT company. They offer various services like mobile app development, UI/UX design, software testing, and more. Although I am unable to share the code related to this project due to client confidentiality",
    liveDemo: "https://24design.netlify.app/",
    github: "",
  },
  {
    id: 8,
    title: "Real Estate",
    img: [realEstateLight, realEstateDark],
    languages: ["Next.js", "Tailwind CSS"],
    description:
      "This is a functional Real Estate Company Website. This website created using Next.js and data fetching from API.  In this website you can buy property, rent property. you can also searc property by filtering",
    liveDemo: "https://next-realestate-woad.vercel.app",
    github: "https://github.com/shSalman009/next-realestate",
  },
];

export const skillsData = [
  {
    id: 1,
    title: "HTML",
    img: html,
  },
  {
    id: 2,
    title: "CSS",
    img: css,
  },
  {
    id: 3,
    title: "JavaScript",
    img: javascript,
  },
  {
    id: 4,

    title: "TypeScript",
    img: typescript,
  },
  {
    id: 5,
    title: "React.js",

    img: react,
  },
  {
    id: 6,
    title: "Redux",
    img: redux,
  },
  {
    id: 7,
    title: "Next.js",
    img: next,
  },
  {
    id: 8,
    title: "Node.js",
    img: node,
  },
];
